import * as React from 'react';
import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components'
import { NodeGlobalOptionsInt } from '../../../../fragments/nodeGlobalOptions';
import FlywheelMenu from './FlywheelMenu';
import SolutionsSection, { SolutionSectionInt } from './SolutionsSection';
 
const Wrap = styled.div`
  padding-top: 2rem;
  position: relative;
`
const RightCol = styled(Col)`
  position: relative; 
  padding-left: 2rem;
  @media only screen and (max-width: 991px) {
    text-align: center;
    padding-left: 0 !important;
    margin-bottom: 5rem;
  }
`
 
const SolutionsSections = ({ block }: { block: NodeGlobalOptionsInt }) => {
  const [currSol, setCurrSol] = useState(0);
  // console.log('block: ', block);
  const solutions = block.socials ? block.socials : [];
  return (
    <Wrap>
      <Container>
        <Row>
          <Col lg={6} xs={12} style={{position: 'relative'}}>
            <FlywheelMenu solutions={solutions} currSol={currSol} setCurrSol={setCurrSol} />
          </Col>
          <RightCol lg={6} xs={12} style={{position: 'relative', padding: '0 0 2rem 2rem'}}>
            {solutions.map((sol: SolutionSectionInt, i: number) => <SolutionsSection solution={sol} currSol={currSol} i={i} key={`solution-${i}`} />)}
          </RightCol>
        </Row>
      </Container>
    </Wrap>
  )
}
 
export default SolutionsSections


